
import { Box, Modal } from "@mui/material";
import Button from "@mui/material/Button";
import React, { useState, useRef, useEffect } from "react";
import { isEmptyDash, strToDate } from "../../constant";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
};
const ConfirmTableListModal = (props) => {
    const [columns, setColumns] = useState(props?.tableColumn);
    const [listing, setListing] = useState(props?.tableData);

    useEffect(() => {
        setListing(props?.tableData);
        setColumns(props?.tableColumn);
        // console.log(props);
        
    }, [props?.tableData, props?.tableColumn]);

    const onSubmit = () => {
        props?.submitAction(listing); 
    }

    return (
        <>
            {/* Delete Modal */}
            <Modal
                open={props?.isConfirmTableModalOpen}
                onClose={props.closeConfirmTableModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box
                    sx={style}
                    className="modal_react_controlpanel_employee MuiBox-root css-1wnsr1i"
                >
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">{props?.headerText}</h5>
                        <button
                            type="button"
                            className="btn-close"
                            aria-label="Close"
                            onClick={props.closeConfirmTableModal}
                        ></button>
                    </div>
                    <div className="listing_main" style={{ overflowX: "scroll", marginTop: "15px" }}>
                    <table>
                    <thead>
                        <tr>
                        <th className="vendor_tabels">
                            <input type="checkbox" />
                        </th>
                        {columns.map((column, index) => (<>
                            <th className="vendor_tabels ">
                            <div className="PoDetailTableHeading">
                                <div className="d-flex">
                                <p>{column?.label}</p>
                                {/* {(column.isSort == true) && <span onClick={(e) => onSortChange(index, column.id, column.sortLabel)} className="table-sort-ico">
                                    {(column.sortLabel != "asc") && <img src={topArrow} />}
                                    {(column.sortLabel == "asc") && <img src={topHighlightArrow} />}
                                    {(column.sortLabel != "desc") && <img src={bottomArrow} />}
                                    {(column.sortLabel == "desc") && <img src={bottomHighlightArrow} />}
                                </span>} */}
                                </div>
                            </div>
                            </th>
                        </>))}
                        </tr>
                    </thead>
                    
                    <tbody style={{ overflowY: "scroll", width: "200px" }}>
                            {listing?.length < 1 && <>
                            <tr>
                                <td colSpan={8} className="text-center list-no-data">No Data Found</td>
                            </tr>
                            </>}
                            {listing?.map((productData, i) => (<>
                            <tr className="maine_tr_vendor" key={productData["_id"]}>
                                <td>
                                    <input type="checkbox" />
                                </td>
                                {columns.map((column, j) => (column?.formate == "TEXT") ?
                                <td>{productData[column?.id]}</td> : (column?.formate == "INPUT_TEXT") ?
                                <td>{productData[column?.id]}</td> : (column?.formate == "RATE") ?
                                        <td> ₹{isEmptyDash(productData[column?.id]) ? 0 : productData[column?.id]} </td> : (column?.formate == "DATE") ?
                                        <td>{strToDate(productData[column?.id])}</td> : null)}
                            </tr>
                            </>))}

                        </tbody>
                    </table>
                    
                </div>
                <div className="text-center">
                        <button className="btn btn-danger" onClick={() => props?.closeConfirmTableModal()}>No</button>
                        <button   onClick={onSubmit} className="btn btn-success">Yes</button>
                    </div>
                </Box>
                
            </Modal>
        </>
    );
};

export default ConfirmTableListModal;